import styled from "@emotion/styled";
import Colors from "/styles/colors";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import { TOP_LAYER } from "constants/z-index";
const COSTUME_SELECT_BACKGROUND_COLOR = "#dff0ff";
const COSTUME_SELECT_BORDER_COLOR = "#1e90ff";
const COSTUME_SELECT_OPTIONS_BORDER_COLOR = "#ccc";
const COSTUME_SELECT_TEXT_COLOR = "#0085ff";
export const StyledCustomSelect = styled.div`
  position: relative;
  width: 100%;
  margin: auto;

  .custom-select-selection {
    padding: 12px 12px 12px 16px;
    background-color: ${COSTUME_SELECT_BACKGROUND_COLOR};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 42px;
    border-radius: 2px;
    .down-arrow {
      display: flex;
      align-items: center;
      .picture-component {
        display: flex;
        align-items: center;
        img {
          height: 14px;
          width: 14px;
        }
      }
    }
    .label {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &.with-border {
      outline: 1px solid ${COSTUME_SELECT_BORDER_COLOR};
    }
  }

  .custom-select-options {
    position: absolute;
    width: 100%;
    background-color: ${Colors[WHITE_COLOR_NAME]};
    border: 1px solid ${COSTUME_SELECT_OPTIONS_BORDER_COLOR};
    margin-top: 8px;
    padding-left: 0;
    max-height: 300px;
    overflow: auto;
    z-index: ${TOP_LAYER};
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);

    .custom-select-option {
      list-style: none;
      padding: 8px 8px 8px 20px;
      cursor: pointer;
      text-align: left;

      &.is-selected {
        background-color: ${COSTUME_SELECT_BACKGROUND_COLOR};
        color: ${COSTUME_SELECT_TEXT_COLOR};
      }

      a {
        text-decoration: none;
        color: inherit;
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }
`;
